import { useMsal } from "@azure/msal-react";
import { setMsalContext } from "services/apiClient";

import { AUTH_BYPASS } from "../App";

export function useMsalSync() {
  // eslint-disable-next-line react-hooks/rules-of-hooks -- AUTH_BYPASS is a build-time constant, never changes at runtime
  const msal = AUTH_BYPASS ? { instance: null, accounts: [] } : useMsal();

  // Set MSAL context synchronously during render so that child components
  // (e.g. DashboardPage) have auth headers available when their TanStack
  // Query hooks fire on first mount — a useEffect would run too late.
  if (!AUTH_BYPASS) {
    const account = msal.accounts[0];
    if (account && msal.instance) {
      setMsalContext(msal.instance, account);
    }
  }
}
